import { combineReducers } from 'redux';
import type { UserPreferencesState } from '../userPreferencesModel';
import { userPreferenceShowReducer } from './userPreferencesShowReducer';
import { userPreferenceDataReducer } from './userPreferencesDataReducer';

export const userPreferencesReducer = combineReducers<UserPreferencesState>({
  showUserPreferences: userPreferenceShowReducer,
  data: userPreferenceDataReducer,
});
